<template>
  <div class="overlay" :class="{ 'is-svg': data.isSvg }" :style="overlayStyles">
    <div class="overlay-bg" :style="overlayStyles"></div>
    <div v-if="data.attributesText">
      <span
        v-for="(attributeText, index) in data.attributesText"
        :key="index"
        class="attribute-text"
      >
        {{ attributeText }}
      </span>
    </div>
    <div class="top-tag-container">
      <div v-if="isPremium && !isMerchOnly" class="formerch">
        <div class="icon-container">
          <img
            src="https://cdn.vexels.com/img/icons/crown.svg"
            class="icon"
            :alt="$t('preview.main.content.crownAlt')"
            height="20"
            width="20"
            loading="lazy"
          />
        </div>
        <span class="text">{{ $t('preview.main.content.premium') }}</span>
      </div>
      <div v-if="isMerchOnly" class="formerch">
        <span class="text">{{ $t('preview.main.content.forMerch') }}</span>
        <div class="icon-container">
          <img
            src="https://cdn.vexels.com/img/icons/merch_only.svg"
            class="icon"
            :alt="$t('preview.main.content.merchOnlyIconAlt')"
            width="28"
            height="20"
            loading="lazy"
          />
        </div>
      </div>
      <div class="like-container" @click="likeVector(data.id)">
        <div class="icon-container">
          <Icon class="icon" color="#ffffff" :height="30" :width="30" :icon="likeIcon" />
        </div>
        <span class="text">{{ $t('preview.main.content.save') }}</span>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Icon from 'UI/Icon';

export default {
  name: 'OverlayPreview',
  components: {
    Icon
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    likeIcon() {
      return this.isLiked ? 'like-full' : 'like-empty';
    },
    overlayStyles() {
      return `border-radius: ${this.data.borderRadius}px;`;
    },
    isLiked() {
      return this.$store.getters['user/isVectorLiked'](parseInt(this.data.id));
    },
    isPremium() {
      if (!this.data.attributes) return false;
      return this.data.attributes.some((el) => Number(el.id) == this.$g('PREMIUM_ATTRIBUTE_CODE'));
    },
    isMerchOnly() {
      if (!this.data.attributes) return false;
      return this.data.attributes.some(
        (el) => Number(el.id) == this.$g('MERCH_ONLY_ATTRIBUTE_CODE')
      );
    }
  },
  methods: {
    likeVector(idVector) {
      this.$store.dispatch('user/SET_LIKE_VECTOR', {
        idVector,
        isLiked: this.isLiked,
        bvModal: this.$bvModal
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: 0.4s ease;
  overflow: hidden;
  top: 0;
  &.is-svg {
    width: calc(100% - 30px);
  }
  div {
    z-index: 100;
  }
  .attribute-text {
    float: left;
    margin-top: 10px;
    margin-left: 10px;
    padding: 5px 10px;
    background-color: white;
    border-radius: 4px;
    box-shadow: 0px 3px 6px #00000017;
    -webkit-box-shadow: 0px 3px 6px #00000017;
    -moz-box-shadow: 0px 3px 6px #00000017;
    display: flex;
    font-size: 14px;
  }
}
.like-container {
  width: 38px;
  height: 38px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  z-index: 2;
  border-radius: 7px;
  margin-top: 10px;
  transition: all 0.3s ease-out;
  box-sizing: border-box;
}
.text {
  font-size: 10px;
  min-width: 10px;
  padding: 10px;
  width: max-content;
  position: absolute;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: inherit;
  color: #fff;
  transform: scaleX(0);
  border-radius: 7px 0px 0px 7px;
  top: 0;
  right: 38px;
  opacity: 0;
  transform-origin: right center;
  z-index: -1;
  transition: inherit;
  box-sizing: border-box;
}
.like-container:hover {
  background-color: #fb556b;
  border-radius: 0px 7px 7px 0px;
}
.like-container:hover .text {
  right: 37px;
  transform: scaleX(1);
  opacity: 1;
}

.like-container .icon-container {
  margin-bottom: 10px;
}
.top-tag-container {
  float: right;
  margin-top: 10px;
  margin-right: 10px;
  display: flex;
  flex-flow: column;
  align-items: flex-end;
}
.formerch {
  width: 38px;
  height: 38px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  z-index: 2;
  border-radius: 7px;
  margin-top: 10px;
  transition: all 0.3s ease-out;
  box-sizing: border-box;
}
.formerch:hover {
  border-radius: 0px 4px 4px 0px;
}
.formerch:hover .text {
  right: 38px;
  transform: scaleX(1);
  opacity: 1;
}
.icon-container {
  height: 20px;
  position: absolute;
  right: 0;
  width: 38px;
  display: flex;
  align-content: center;
}
.icon-container > .icon {
  height: 100%;
  margin: auto;
}
.formerch:hover {
  opacity: 1;
}
</style>
